module.exports = __webpack_public_path__ + "img/hospital-two.528f64b9.png";